/* eslint-disable */
export const getToken = () => !!localStorage.getItem('token') ? localStorage.getItem('token') : false;

export const isLogin = () => !!localStorage.getItem('token') ? true : false;
